import React from "react";
import { Requests } from "../../api/IdentityServerRequests/Requests";
import "@dmuy/toast/dist/mdtoast.css";
import mdtoast from "@dmuy/toast";
import ReactDOM from 'react-dom';
import {
  format,
  addDays,
  differenceInDays,
  getDay,
  startOfWeek,
  startOfDay,
  endOfWeek,
  addMonths,
  set,
  addWeeks,
  subDays,
  isWithinInterval,
} from "date-fns";
import Loader from "../../components/UI/Loading/Loading";

const scheduler = window.scheduler;
const ThreeDaysViewName = 'multidays';
const WeekViewName = 'week';
const BiweeklyViewName = 'biweekly';
export default class MyScheduler extends React.Component {
  constructor(props) {
    super(props);
    this.Requests = new Requests();
    this.schedulerHeaderlabels = this.schedulerHeaderlabels.bind(this);
    this.schedulerSubHeaderContent = this.schedulerSubHeaderContent.bind(this);
    this.viewByValueChange = this.viewByValueChange.bind(this);
    this.retrieveDocNode = this.retrieveDocNode.bind(this);
    this.updateSurroundingMonths = this.updateSurroundingMonths.bind(this);
    this.dayLabelsClickHandler = this.dayLabelsClickHandler.bind(this);
    this.carouselRef = React.createRef();
    this.undoStack = [];
    this.redoStack = [];
    this.maxStackSize = 20; // Maximum number of undo/redo actions to store
    this.uncommittedChanges = [];
    this.uncommittedChangePayload = [];
    this.state = {
      eventData: {},
      isMobilePortrait: window.innerWidth <= 768,
      currentMonthIndex: 0,
      surroundingMonths: [],
      currentMonth: new Date(),
      selectedTimeSlots: [],
      selectedDateSlots: [],
      undoIndex: -1, // Initialize to -1 indicating no actions yet
      redoIndex: -1,  // Initialize to -1 indicating no actions yet
      selectedViewType: '',
      isComponentLoading: false,
      windowHeight: window.innerHeight,
    };
    this.previousTimeSlot = null;
  }
  // mini calender popup
  showCalendar = () => {
    const shortScreen = window.innerHeight < 500
    const calIcon = document.querySelector('.dhx_minical_icon')
    const bottom = calIcon.getBoundingClientRect().bottom
    const left = calIcon.getBoundingClientRect().left - 135 + 50
    const centerPosition = { left: (window.innerWidth / 2) - 135, top: (window.innerHeight / 2) - 160 }
    if (scheduler.isCalendarVisible()) {
      scheduler.destroyCalendar();
    } else {
      scheduler.renderCalendar({
        position: shortScreen ? centerPosition : { left: left, top: bottom },
        date: scheduler._date,
        navigation: true,
        handler: (date, calendar) => {
          scheduler.setCurrentView(date);
          this.props.addNotchSafePadding(); // re-add notch safe padding after view update
          this.getAvailabilityByView();
          this.updateSurroundingMonths(date);
          scheduler.destroyCalendar()
        }
      });
    }
  }
  schedulerHeaderlabels(dates, nav) {
    const selectedDate = dates.join(' ');
    const html = `
     <div class='dhx_date_header_labels_container'>
      ${nav?.leftNav ? "<div id='prev-button' class='dhx_cal_prev_button dhx_cal_nav_button dhx_cal_week_prev_custom' role='button' aria-label='Previous'></div>" : ""}
        <div class='dhx_date_header_labels' aria-label='${selectedDate}' >
          <div>${dates[0]}</div>
          <div>${dates[1]}</div>
        </div>
      ${nav?.rightNav ? "<div id='next-button' class='dhx_cal_next_button dhx_cal_nav_button dhx_cal_week_next_custom' role='button' aria-label='Next'></div>" : ""}
    </div>
  `;
    return html;
  }
  viewByValueChange(selectedValue) {
    const weekStart = startOfWeek(scheduler.getState().min_date, { weekStartsOn: 1 });
    let seletedViewName = '';
    switch (selectedValue) {
      case "Weekly":
        seletedViewName = WeekViewName;
        scheduler.setCurrentView(weekStart, WeekViewName);
        break;
      case "3 day":
        scheduler.setCurrentView(scheduler.getState().min_date, ThreeDaysViewName);
        seletedViewName = ThreeDaysViewName;
        break;
      case "Bi-weekly":
        scheduler.setCurrentView(weekStart, BiweeklyViewName);
        seletedViewName = BiweeklyViewName;
        break;
      default:
        break;
    }
    this.props.addNotchSafePadding();
    this.setState({ selectedViewType: seletedViewName }, () => {
      this.updateSurroundingMonths(weekStart);
    });
    this.getAvailabilityByView();
  }
  retrieveDocNode(cssClassName) {
    return document.querySelector(cssClassName);
  }
  schedulerCurrentMonthHeader(currentMonth) {
    const newDiv = document.createElement('div');
    newDiv.className = "dhx_cal_current_month carousel-month";
    newDiv.setAttribute('aria-label', currentMonth);

    const newSpan = document.createElement('span');
    newSpan.className = "dhx_minical_icon";
    newSpan.id = "dhx_minical_icon";
    newSpan.textContent = currentMonth;
    newSpan.onclick = this.showCalendar;

    newDiv.appendChild(newSpan);

    return newDiv;
  }
  renderViewByDropdown() {
    return (
      <select
        className="headerViewBy"
        value={this.state.viewBy}
        onChange={(e) => this.viewByValueChange(e)}
      >
        <option value="none">View by</option>
        <option value={ThreeDaysViewName}>3 Days</option>
        <option value={WeekViewName}>Week</option>
        {!this.state.isMobilePortrait && (<option value={BiweeklyViewName}>Biweekly</option>)}
      </select>
    );
  }
  renderUndoButton() {
    return (
      <div
        id="dhx_undo_button"
        className="dhx_cal_undo_button"
        onClick={this.handleUndoClick}>
        <span className="icon"></span>
        Undo
      </div>
    );
  }

  renderRedoButton() {
    return (
      <div
        id="dhx_redo_button"
        className="dhx_cal_redo_button"
        onClick={this.handleRedoClick}>
        <span className="icon"></span>
        Redo
      </div>
    );
  }

  handleRedoClick = () => {
    if (this.redoStack.length !== 0 && this.state.redoIndex <= this.redoStack.length - 1) {
      const redoItem = this.redoStack[this.state.redoIndex];
      let {
        snapshot,
        start,
        end,
        viewStart,
        eventStart,
        datesWithChanges
      } = redoItem
      switch (this.props.viewByRange) {
        case '3 day':
          if ((eventStart < viewStart) || (eventStart > addDays(viewStart, 3))) {
            viewStart = eventStart
          }
          break;
        case 'Weekly':
          viewStart = start;
          break;
        default:
          viewStart = startOfWeek(viewStart, { weekStartsOn: 1 })
          break
      }
      // Add the current redo element to this.uncommittedChanges
      if (this.state.redoIndex >= 0) {
        this.uncommittedChanges.push(redoItem);
      }

      scheduler.setCurrentView(viewStart);
      this.props.addNotchSafePadding();
      this.updateSurroundingMonths(viewStart)
      // Restore snapshot:
      // push a snapshot to undo
      // 1. Clear the events between start and end
      datesWithChanges.forEach(date => {
        const startOfDay = new Date(date).setHours(0, 0, 0, 0);
        const endOfDay = new Date(date).setHours(23, 59, 59, 0);
        const eventsOfDay = scheduler.getEvents(startOfDay, endOfDay);
        eventsOfDay.forEach(event => {
          scheduler.deleteEvent(event.id);
        });
      });

      // 2. Add the events in snapshot back to the calendar
      snapshot.forEach((e) => this.addEvent(e))
      this.generateUncommittedPayloadOffChanges();
      this.setState(prevState => {
        const newRedoIndex = prevState.redoIndex + 1;
        const newUndoIndex = prevState.undoIndex + 1;
        return { undoIndex: newUndoIndex < 0 ? 0 : newUndoIndex, redoIndex: newRedoIndex < 0 ? 0 : newRedoIndex };
      });
    } else {
      this.toastie("Already at latest change", "error")
    }
  }

  handleUndoClick = () => {
    if (this.state.undoIndex > 0) {
      this.setState(prevState => {
        const newUndoIndex = prevState.undoIndex - 1;
        const newRedoIndex = prevState.redoIndex - 1;
        const undoItem = this.undoStack[newUndoIndex];
        // snap to the view where change is being reverted
        let {
          snapshot,
          start,
          end,
          viewStart,
          eventStart,
          datesWithChanges
        } = undoItem;
        switch (this.props.viewByRange) {
          case '3 day':
            if ((eventStart < viewStart) || (eventStart > addDays(viewStart, 3))) {
              viewStart = eventStart
            }
            break;
          case 'Weekly':
            viewStart = start;
            break;
          default:
            viewStart = startOfWeek(viewStart, { weekStartsOn: 1 })
            break
        }
        scheduler.setCurrentView(viewStart);
        this.updateSurroundingMonths(viewStart)
        if (this.state.undoIndex >= 0) {
          this.uncommittedChanges.push(undoItem);
        }
        // 1. Clear the events on updated dates
        datesWithChanges.forEach(date => {
          //const currentDate = new Date(date);
          const startOfDay = new Date(date).setHours(0, 0, 0, 0);
          const endOfDay = new Date(date).setHours(23, 59, 59, 0);
          const eventsOfDay = scheduler.getEvents(startOfDay, endOfDay);
          eventsOfDay.forEach(event => {
            scheduler.deleteEvent(event.id);
          });
        });
        // 2. Add the events in snapshot back to the calendar
        snapshot.forEach((e) => this.addEvent(e));
        this.generateUncommittedPayloadOffChanges();
        return { undoIndex: newUndoIndex < 0 ? 0 : newUndoIndex, redoIndex: newRedoIndex < 0 ? 0 : newRedoIndex };
      }, () => {
        // Call addNotchSafePadding AFTER all state updates and view resets
        if (this.props.addNotchSafePadding) {
          this.props.addNotchSafePadding();
        }
      });
    } else {
      this.toastie("Nothing to undo", "error")
    }
  }

  loadUncommittedChangesFromWeek = (date) => {
    const weekStart = startOfWeek(new Date(date), { weekStartsOn: 1 })
    const weekInList = this.uncommittedChanges.find(e => e.date.getTime() == weekStart.getTime())
    return { weekStart, weekInList };
  }

  generateUncommittedPayloadOffChanges = () => {
    const uniqueDates = new Set();
    this.uncommittedChangePayload = [];
    this.uncommittedChanges.forEach(item => {
      item.datesWithChanges.forEach(date => {
        uniqueDates.add(date);
      });
    });
    uniqueDates.forEach(date => {
      const startOfDay = new Date(date).setHours(0, 0, 0, 0);
      const endOfDay = new Date(date).setHours(23, 59, 59, 0);
      const eventsOfDay = scheduler.getEvents(startOfDay, endOfDay);

      const availabilities = eventsOfDay.map(event => ({
        timeStart: new Date(event.start_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        timeEnd: new Date(event.end_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        availabilityTypes: event.eventType.includes('Unavailable') ? null : event.eventType,
        isUnavailable: event.eventType.includes('Unavailable')
      }));
      this.uncommittedChangePayload.push({
        date,
        pagingNumber: this.props.selectedPagingGroups,
        availabilities
      });
    });
    this.props.updateChanges(this.uncommittedChangePayload);
  }
  pushSnapshotToUndoRedoStack = (stack, events, addUncommitted, isShortRecurrent) => {
    // push the snapshot onto the stack 
    const snapshots = [];
    let earliestEventDate = null;
    let updatedDates = [];
    // Iterate over changed dates and extract the events for snapshots
    events.forEach(event => {
      // Extract the current_date property
      const currentDate = event.currentDate;
      updatedDates.push(currentDate);
      // Define the start and end of the day
      const startOfDay = new Date(currentDate).setHours(0, 0, 0, 0);
      const endOfDay = new Date(currentDate).setHours(23, 59, 59, 0);
      // Get all events for the current day
      const eventsOfDay = scheduler.getEvents(startOfDay, endOfDay);
      // Add the events of the day to the allEvents array
      if (isShortRecurrent) {
        // avoid duplicates in snapshots if it's from the short form
        eventsOfDay.forEach(event => {
          const eventExists = snapshots.some(snapshot =>
            snapshot.start_date === event.start_date &&
            snapshot.end_date === event.end_date &&
            snapshot.eventType === event.eventType &&
            snapshot.currentDate === event.currentDate
          );

          if (!eventExists) {
            snapshots.push({
              start_date: event.start_date,
              end_date: event.end_date,
              eventType: event.eventType,
              currentDate: event.currentDate,
            });
          }
        });
      } else {
        snapshots.push(...eventsOfDay.map(event => ({
          start_date: event.start_date,
          end_date: event.end_date,
          eventType: event.eventType,
          currentDate: event.currentDate,
        })));
      }
      if (!earliestEventDate || new Date(event.start_date) < earliestEventDate) {
        earliestEventDate = new Date(event.start_date);
      }
    });
    const action = {
      snapshot: snapshots,
      start: scheduler.getState().min_date,
      end: scheduler.getState().max_date,
      viewStart: scheduler.getState().min_date,
      eventStart: earliestEventDate,
      datesWithChanges: Array.from(new Set(updatedDates))
    };
    if (stack.length >= this.maxStackSize) {
      stack.shift(); // Remove the oldest snapshot
    }
    stack.push(action);

    if (addUncommitted) {
      this.uncommittedChanges.push(action);
    }
    this.generateUncommittedPayloadOffChanges();
  };

  addEvent = (event) => {
    scheduler.addEvent(event)
  }
  updateEvent = (event) => {
    scheduler.updateEvent(event.id);
  }

  deleteEvent = (event) => {
    scheduler.deleteEvent(event.id)
  }

  getCurrentMonth = () => {
    const state = scheduler.getState();
    const currentDate = state.date;
    const currentMonthDetails = this.formatDateString(currentDate);
    const [month, year] = currentMonthDetails.split(' ');
    return { month, year };
  };
  // get months Aug, Sep, Oct(current), Nov, Dec
  getSurroundingMonths = (currentMonth, numOfMonths) => {
    const options = { year: 'numeric', month: 'long' };
    const monthFormat = date => new Intl.DateTimeFormat('default', options).format(date)
    const months = [];
    currentMonth.setDate(1);
    for (let i = numOfMonths; i > 0; i--) {
      const date = new Date(currentMonth);
      date.setMonth(currentMonth.getMonth() - i);
      months.push(monthFormat(date));
    }
    months.push(monthFormat(currentMonth));
    for (let i = 1; i <= numOfMonths; i++) {
      const date = new Date(currentMonth);
      date.setMonth(currentMonth.getMonth() + i);
      months.push(monthFormat(date));
    }
    return months;
  };
  formatDateString = (date) => {
    const smallScreen = window.innerWidth <= 768
    const options = { year: smallScreen ? '2-digit' : 'numeric', month: smallScreen ? 'short' : 'long' };
    return new Intl.DateTimeFormat('default', options).format(date);
  };
  monthCarousel() {
    const carousel = this.carouselRef.current;
    if (window.innerWidth < 932) {
      carousel.style.transform = 'translateX(0px)';
    } else {
      const itemWidth = window.innerWidth > 768 && window.innerWidth < 1299 ? 3.5 * 16 + 5 : 4.5 * 16 + 5; // 9rem in pixels
      const scrollPosition = -1 * this.state.currentMonthIndex * itemWidth;
      carousel.style.transform = `translateX(${scrollPosition}px)`;
    }
  }
  updateSurroundingMonths = (miniCalDate) => {
    try {
      const date = miniCalDate ? new Date(miniCalDate) : new Date();
      const surroundingMonths = this.getSurroundingMonths(date, 5);
    this.setState({
        surroundingMonths: surroundingMonths,
        currentMonthIndex: 0,
        currentMonth: date
      }, () => {
        const carousel = this.carouselRef.current;
        carousel.style.transform = 'translateX(0px)';
      });
    } catch (error) {
      console.error("Error updating surrounding months:", error);
    }
  };
  schedulerHeaderDetails() {
    const currentMonth = this.formatDateString(this.state.currentMonth)
    return (
      <div className="headerDetails">
        {this.props.popupButtons?.addAvailabilityButton}
        {this.props.popupButtons?.setPagingGroupButton}
        {this.state.isMobilePortrait && this.renderUndoButton()}
        <div className="carousel-wrapper">
          <div className="dhx_cal_prev_button dhx_cal_prev_month_button dhx_cal_nav_pre_month" role="button" aria-label="Previous"></div>

          <div className="carousel-container">
            <div className="carousel-months" ref={this.carouselRef}>
              {window.innerWidth <= 850 ? (
                <div className="carousel-month active" aria-label={currentMonth} onClick={this.showCalendar}>
                  <span className="dhx_minical_icon" id="dhx_minical_icon">
                    {currentMonth}
                  </span>
                </div>
              ) : (
                this.state.surroundingMonths.map((month, index) => (
                  month === currentMonth ? (
                    <div key={index} className="carousel-month active" aria-label={currentMonth} onClick={this.showCalendar}>
                      <span className="dhx_minical_icon" id="dhx_minical_icon">
                        {currentMonth}
                      </span>
                    </div>
                  ) : (
                    <div key={index} className="carousel-month" aria-label={month}>
                      {month.split(' ')[0]}
                    </div>
                  )
                ))
              )}
            </div>
          </div>
          <div className="dhx_cal_next_button dhx_cal_next_month_button dhx_cal_nav_next_month" role="button" aria-label="Next"></div>
        </div>

        {this.state.isMobilePortrait && this.renderRedoButton()}
        {this.props.popupButtons?.saveButton}
        {this.props.popupButtons?.ellipsesDropdown}
      </div>
    );
  };
  schedulerSubHeaderContent(date) {
    const mode = scheduler.getState().mode;
    const firstDay = scheduler.getState().min_date;
    const lastDay = scheduler.getState().max_date;
    lastDay.setDate(lastDay.getDate() - 1);
    const format = scheduler.date.date_to_str(scheduler.config.day_date);
    const weekStart = scheduler.date.week_start(new Date(scheduler._date));
    const weekEnd = scheduler.date.add(weekStart, 1, mode); //3_days
    // weekly view
    let html = format(date).split(' ');
    const weekDates = scheduler.date.date_part(new Date(date));
    let lastDayOfWeek = new Date(weekEnd);
    lastDayOfWeek.setDate(weekEnd.getDate() - 1);
    const weekEndDate = scheduler.date.date_part(lastDayOfWeek);
    if (mode === ThreeDaysViewName) {
      if (weekDates.getTime() === firstDay.getTime()) {
        html = this.schedulerHeaderlabels(html, { leftNav: true });
      }
      if (weekDates.getTime() > firstDay.getTime() && weekDates.getTime() < lastDay.getTime()) {
        html = this.schedulerHeaderlabels(html);
      }
      if (weekDates.getTime() === lastDay.getTime()) {
        html = this.schedulerHeaderlabels(html, { rightNav: true });
      }
    }
    if (mode === WeekViewName) {
      if (this.state.isMobilePortrait) {
        const dayOfWeek = weekDates.getDay();
        // Check the day of the week and update the html variable accordingly
        if (dayOfWeek === 0 || dayOfWeek === 4 || dayOfWeek === 6) {
          // If it's Sunday (0), Thursday (4), or Saturday (6), keep the first two characters
          html[0] = html[0].slice(0, 2);
        } else {
          // For other days, keep only the first character
          html[0] = html[0].charAt(0);
        }
      }

      if (weekDates.getTime() === weekStart.getTime()) {
        html = this.schedulerHeaderlabels(html, { leftNav: true });
      }
      if (weekDates.getTime() > weekStart.getTime() && weekDates.getTime() < weekEndDate.getTime()) {
        html = this.schedulerHeaderlabels(html);
      }
      if (weekDates.getTime() === weekEndDate.getTime()) {
        html = this.schedulerHeaderlabels(html, { rightNav: true });
      }
    }
    if (mode === BiweeklyViewName) {
      if (weekDates.getTime() === firstDay.getTime()) {
        html = this.schedulerHeaderlabels(html, { leftNav: true });
      }
      if (weekDates.getTime() > firstDay.getTime() && weekDates.getTime() < lastDay.getTime()) {
        html = this.schedulerHeaderlabels(html);
      }
      if (weekDates.getTime() === lastDay.getTime()) {
        html = this.schedulerHeaderlabels(html, { rightNav: true });
      }
    }
    return html;
  }
  addUndoViewByDropdown() {
    // add Undo button and View by dropdown to the scheduler header
    const schedulerContainer = this.retrieveDocNode('.dhx_cal_header');
    if (schedulerContainer) {
      const unDoButton = document.createElement('div');
      unDoButton.className = 'undoButContainer';
      const reDoButton = document.createElement('div');
      reDoButton.className = 'viewByDropdownContainer'
      const viewByDropdown = document.createElement('div');
      viewByDropdown.className = 'viewByDropdownContainer';
      schedulerContainer.insertBefore(unDoButton, schedulerContainer.firstChild);
      schedulerContainer.appendChild(reDoButton)
      // schedulerContainer.appendChild(viewByDropdown);
      ReactDOM.render(this.renderUndoButton(), unDoButton);
      ReactDOM.render(this.renderRedoButton(), reDoButton);
    }
  }
  addOrRemoveTimeRow(add) {
    const schedulerContainer = this.retrieveDocNode('.dhx_cal_header');
    let timeRow = this.retrieveDocNode('.timeRowAfterSubHeader');
    if (add) {
      if (!timeRow) {
        timeRow = document.createElement('div');
        timeRow.className = 'timeRowAfterSubHeader';
        timeRow.textContent = 'Time';
        schedulerContainer.parentNode.insertBefore(timeRow, schedulerContainer.nextSibling);
      }
    } else {
      if (timeRow) {
        timeRow.parentNode.removeChild(timeRow);
      }
    }
  }
  //check daylight saving end date
  isFirstSundayInApril = (date) => {
    // Check if the month is April (month index 3)
    if (date.getMonth() !== 3) {
      return false; // Not April
    }
    // Get the year and the date
    const year = date.getFullYear();
    const day = date.getDate();
    // Find the first day of April
    const firstDayOfApril = new Date(year, 3, 1);
    // Calculate the first Sunday in April
    const firstSunday = new Date(year, 3, 1 + (7 - firstDayOfApril.getDay()) % 7);

    // Check if the given date matches the first Sunday in April
    return date.getTime() === firstSunday.getTime();
  };
  //Full day selection handler
  dayLabelsClickHandler(index, minDate) {
    const selectedDate = addDays(minDate, index);
    const eventsOnDate = scheduler.getEvents(selectedDate, addDays(selectedDate, 1))
    const isUnavailable = this.props.selectedAvailabilityType === 'Unavailable'
    this.setState({ selectedFullDay: selectedDate });
    const isDaylightSavingEnd = this.isFirstSundayInApril(selectedDate);
    const endDate = new Date(selectedDate);
    if (isDaylightSavingEnd) {
      endDate.setHours(22, 59, 0, 0);
    } else {
      endDate.setHours(23, 59, 0, 0);
    }
    const availabilityEvent = {
      start_date: selectedDate,
      end_date: endDate,
      eventType: [this.props.selectedAvailabilityType],
      currentDate: format(selectedDate, "yyyy-MM-dd")
    };
    this.undoStack = this.undoStack.slice(0, this.state.undoIndex);
    this.redoStack = this.redoStack.slice(0, this.state.undoIndex);
    //store the snapshot of the current state before changes
    this.pushSnapshotToUndoRedoStack(this.undoStack, [availabilityEvent], false, false);
    this.setState({ undoIndex: this.undoStack.length });
    // availability type already selected -> clear all events on that day and paint a whole day event
    switch (this.props.selectedAvailabilityType) {
      case 'Delete':
        eventsOnDate.forEach((e) => scheduler.deleteEvent(e.id))
        break;
      case null:
        break;
      default:
        eventsOnDate.forEach((e) => scheduler.deleteEvent(e.id))
        this.onSaveEvent(availabilityEvent);
        // hacky fix for daylight saving end date only, two events are created for this full day selection
        if (isDaylightSavingEnd) {
          this.onSaveEvent({
            start_date: new Date(selectedDate.setHours(23, 0, 0, 0)),
            end_date: new Date(selectedDate.setHours(23, 59, 0, 0)),
            eventType: [this.props.selectedAvailabilityType],
            currentDate: format(selectedDate, "yyyy-MM-dd")
          });
        }
        break;
    }
    // after changes, capture latest changes for redo stack
    this.pushSnapshotToUndoRedoStack(this.redoStack, [availabilityEvent], true, false);
    this.setState({ redoIndex: this.redoStack.length });
  };

  navigateWeekPre = () => {
    let daysInMode = scheduler.getState().mode;
    switch (scheduler.getState().mode) {
      case WeekViewName:
        daysInMode = 7;
        break;
      case ThreeDaysViewName:
        daysInMode = 3;
        break;
      case BiweeklyViewName:
        daysInMode = 14;
        break;
      default:
        break;
    }
    const date = scheduler.getState().min_date;
    const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - daysInMode);
    const newMonth = newDate.getMonth();
    const currentMonth = date.getMonth();
    this.setState((prevState) => {
      let surroundingMonths = prevState.surroundingMonths;
      let currentMonthIndex = prevState.currentMonthIndex;
      // Check if the new date falls into a new month
      if (newMonth !== currentMonth) {
        const firstMonth = surroundingMonths[0];
        const [firstMonthName, firstMonthYear] = firstMonth.split(' ');
        const firstMonthDate = new Date(`${firstMonthName} 1, ${firstMonthYear}`);
        firstMonthDate.setMonth(firstMonthDate.getMonth() - 1);
        const prevMonth = new Intl.DateTimeFormat('default', { month: 'long', year: 'numeric' }).format(firstMonthDate);
        surroundingMonths = [prevMonth, ...surroundingMonths];
        currentMonthIndex -= 1;
      }
      return {
        surroundingMonths,
        currentMonthIndex,
        currentMonth: newDate
      };
    }, () => {
      // Adjust the scroll position to ensure the view doesn't change
      if (!this.state.isMobilePortrait) this.monthCarousel(-1);
    });
    scheduler.setCurrentView(newDate);
    this.props.addNotchSafePadding();
    this.getAvailabilityByView();
  }

  navigateWeekNext = () => {
    let daysInMode = 0;
    switch (scheduler.getState().mode) {
      case WeekViewName:
        daysInMode = 7;
        break;
      case ThreeDaysViewName:
        daysInMode = 3;
        break;
      case BiweeklyViewName:
        daysInMode = 14;
        break;
      default:
        break;
    }
    const date = scheduler.getState().min_date;
    const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + daysInMode);
    const newMonth = newDate.getMonth();
    const currentMonth = date.getMonth();
    this.setState((prevState) => {
      let surroundingMonths = prevState.surroundingMonths;
      let currentMonthIndex = prevState.currentMonthIndex;
      if (newMonth !== currentMonth) {
        const lastMonth = surroundingMonths[surroundingMonths.length - 1];
        const [lastMonthName, lastMonthYear] = lastMonth.split(' ');
        const lastMonthDate = new Date(`${lastMonthName} 1, ${lastMonthYear}`);
        lastMonthDate.setMonth(lastMonthDate.getMonth() + 1);
        const nextMonth = new Intl.DateTimeFormat('default', { month: 'long', year: 'numeric' }).format(lastMonthDate);
        surroundingMonths = [...surroundingMonths, nextMonth];
        currentMonthIndex += 1;
      }
      return { surroundingMonths, currentMonthIndex, currentMonth: newDate };
    }, () => {
      // Adjust the scroll position to ensure the view doesn't change
      if (!this.state.isMobilePortrait) this.monthCarousel(1);
    });
    scheduler.setCurrentView(newDate);
    this.props.addNotchSafePadding();
    this.getAvailabilityByView();
  }
  navigateMonthPre = () => {
    let daysInMode = scheduler.getState().mode;
    const maxDate = new Date(scheduler.getState().max_date);
    maxDate.setDate(maxDate.getDate() - 1);
    var currentDate = daysInMode === BiweeklyViewName ? maxDate : scheduler.getState().date;
    // Subtract one month from the current date
    var preMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    this.setState((prevState) => {
      const firstMonth = prevState.surroundingMonths[0];
      const [firstMonthName, firstMonthYear] = firstMonth.split(' ');
      const firstMonthDate = new Date(`${firstMonthName} 1, ${firstMonthYear}`);
      firstMonthDate.setMonth(firstMonthDate.getMonth() - 1);
      const prevMonth = new Intl.DateTimeFormat('default', { month: 'long', year: 'numeric' }).format(firstMonthDate);
      const surroundingMonths = [prevMonth, ...prevState.surroundingMonths];
      return { surroundingMonths, currentMonthIndex: prevState.currentMonthIndex - 1, currentMonth: preMonthDate };
    }, () => {
      // Adjust the scroll position to ensure the view doesn't change
      if (!this.state.isMobilePortrait) this.monthCarousel(-1);
    });
    if (daysInMode === WeekViewName)
      scheduler.setCurrentView(preMonthDate, WeekViewName);
    if (daysInMode === ThreeDaysViewName)
      scheduler.setCurrentView(preMonthDate, ThreeDaysViewName);
    if (daysInMode === BiweeklyViewName)
      scheduler.setCurrentView(preMonthDate, BiweeklyViewName);
    this.props.addNotchSafePadding();
    this.getAvailabilityByView();
  }
  navigateMonthNext = () => {
    let daysInMode = scheduler.getState().mode;
    var currentDate = scheduler.getState().date;
    // Add one month from the current date
    var nextMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    this.setState((prevState) => {
      const lastMonth = prevState.surroundingMonths[prevState.surroundingMonths.length - 1];
      const [lastMonthName, lastMonthYear] = lastMonth.split(' ');
      const lastMonthDate = new Date(`${lastMonthName} 1, ${lastMonthYear}`);
      lastMonthDate.setMonth(lastMonthDate.getMonth() + 1);
      const nextMonth = new Intl.DateTimeFormat('default', { month: 'long', year: 'numeric' }).format(lastMonthDate);
      const surroundingMonths = [...prevState.surroundingMonths, nextMonth];
      return { surroundingMonths, currentMonthIndex: prevState.currentMonthIndex + 1, currentMonth: nextMonthDate };
    }, () => {
      // Adjust the scroll position to ensure the view doesn't change
      if (!this.state.isMobilePortrait) this.monthCarousel(1);
    });
    // Set the current view to the previous month
    if (daysInMode === WeekViewName)
      scheduler.setCurrentView(nextMonthDate, WeekViewName);
    if (daysInMode === ThreeDaysViewName)
      scheduler.setCurrentView(nextMonthDate, ThreeDaysViewName);
    if (daysInMode === BiweeklyViewName)
      scheduler.setCurrentView(nextMonthDate, BiweeklyViewName);
    this.getAvailabilityByView();
    this.props.addNotchSafePadding();
  }
  detectSwipeBehavior = () => {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    let startTime = 0;
    // Minimum distance for a swipe
    const minSwipeDistance = 50;
    // Time for a swipe (ms)
    const touchTimeThreshold = 300;
    const schedulerElement = document.querySelector('#scheduler');
    if (schedulerElement && !schedulerElement.hasSwipeEventListeners) {
      schedulerElement.hasSwipeEventListeners = true;
      this.detectTouchStart = (event) => {
        const touch = event.touches[0];
        startX = touch.pageX;
        startY = touch.pageY;
        endX = touch.pageX;
        endY = touch.pageY;
        // Record the start time
        startTime = new Date().getTime();
      };
      this.detectTouchMove = (event) => {
        const touch = event.touches[0];
        endX = touch.pageX;
        endY = touch.pageY;
      };
      this.detectTouchEnd = () => {
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        const elapsedTime = new Date().getTime() - startTime;
        if (elapsedTime < touchTimeThreshold && Math.abs(deltaX) > minSwipeDistance && Math.abs(deltaY) < minSwipeDistance) {
          if (deltaX > 0) {
            //swipe to the right
            this.navigateWeekPre();
          } else {
            //swipe to the left
            this.navigateWeekNext();
          }
        }
      };
      schedulerElement.addEventListener('touchstart', this.detectTouchStart);
      schedulerElement.addEventListener('touchmove', this.detectTouchMove);
      schedulerElement.addEventListener('touchend', this.detectTouchEnd);
    }
  }
  attachEvents() {
    const labelsHeader = document.querySelectorAll('.dhx_date_header_labels');
    const myAvailNavPreWeek = this.retrieveDocNode('.dhx_cal_week_prev_custom');
    const myAvailNavNexWeek = this.retrieveDocNode('.dhx_cal_week_next_custom');
    const myAvailNavPreMonth = this.retrieveDocNode('.dhx_cal_nav_pre_month');
    const myAvailNavNextMonth = this.retrieveDocNode('.dhx_cal_nav_next_month');
    const minDate = scheduler.getState().min_date;
    labelsHeader.forEach((label, index) => {
      label?.removeEventListener('click', () => this.dayLabelsClickHandler(index, minDate));
      if (label && label.dataset?.hasClickListener !== 'true') {
        label?.addEventListener('click', () => this.dayLabelsClickHandler(index, minDate));
        label.dataset.hasClickListener = 'true';
      }
    });

    if (myAvailNavPreWeek && myAvailNavPreWeek?.dataset.hasClickListener !== 'true') {
      myAvailNavPreWeek?.addEventListener('click', this.navigateWeekPre);
      myAvailNavPreWeek.dataset.hasClickListener = 'true';
    }
    if (myAvailNavNexWeek && myAvailNavNexWeek?.dataset.hasClickListener !== 'true') {
      myAvailNavNexWeek?.addEventListener('click', this.navigateWeekNext);
      myAvailNavNexWeek.dataset.hasClickListener = 'true';
    }
    if (myAvailNavPreMonth && myAvailNavPreMonth?.dataset.hasClickListener !== 'true') {
      myAvailNavPreMonth?.addEventListener('click', this.navigateMonthPre);
      myAvailNavPreMonth.dataset.hasClickListener = 'true';
    }
    if (myAvailNavNextMonth && myAvailNavNextMonth?.dataset.hasClickListener !== 'true') {
      myAvailNavNextMonth?.addEventListener('click', this.navigateMonthNext);
      myAvailNavNextMonth.dataset.hasClickListener = 'true';
    }
    this.detectSwipeBehavior();
  }
  controlDynamicMargin(value, in_min, in_max, out_min, out_max) {
    return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  };
  // updating the margin top value of the time scale dynamically
  handleWindowResizeChange = () => {
    const isMobilePortrait = window.innerWidth <= 768;
    this.setState({ isMobilePortrait, windowHeight: window.innerHeight }, this.updateSchedulerHeight);
  };
  updateSchedulerHeight = () => {
    const { windowHeight } = this.state;
    // remove/reset biweekly view to week view on mobile view
    if (this.state.isMobilePortrait) {
      this.addOrRemoveTimeRow(false);
    } else {
      this.addOrRemoveTimeRow(true);
    }
    if (this.state.isMobilePortrait && scheduler.getState().mode === BiweeklyViewName) {
      this.setState({ selectedViewType: WeekViewName });
      this.props.changeViewByRange("Weekly")
    }
    //dynamic margin top for time scale column
    const availableHeightOffset = this.state.isMobilePortrait ? 220 : 265;
    const availableHeight = (window.visualViewport ? window.visualViewport.height * window.visualViewport.scale : windowHeight) - availableHeightOffset;
    let newMarginTopValue = this.controlDynamicMargin(availableHeight, 540, 1000, -0.5, -1.2);
    newMarginTopValue = Math.min(-0.5, Math.max(newMarginTopValue, -1.2));
    document.documentElement.style.setProperty('--time-margin-top', `${newMarginTopValue}rem`);
    const hour_size_px = this.controlDynamicMargin(Math.min(Math.max(availableHeight, 250), 1200), 250, 1200, window.innerWidth > windowHeight && availableHeight < 350 ? 15 : 9, 48.5);
    scheduler.xy.min_event_height = hour_size_px / 2;
    scheduler.config.hour_size_px = hour_size_px;
    // reset the carousel position after window resize
    this.monthCarousel();
    scheduler.setCurrentView();
    this.props.addNotchSafePadding();
  };
  getFirstLastDayOfCurrentView = (firstDayOfView = null) => {
    const mode = scheduler.getState().mode;
    const currentViewStartDate = firstDayOfView ? firstDayOfView : new Date(scheduler.getState().min_date);
    let daysInMode;

    switch (mode) {
      case WeekViewName:
        daysInMode = 7;
        break;
      case ThreeDaysViewName:
        daysInMode = 3;
        break;
      case BiweeklyViewName:
        daysInMode = 14;
        break;
    }
    const firstDay = currentViewStartDate;
    const lastDay = addDays(firstDay, daysInMode - 1);
    return { firstDay, lastDay };
  }
  isUncommittedInCurrentView = () => {
    const mode = scheduler.getState().mode;
    const currentViewStartDate = new Date(scheduler.getState().min_date);
    let daysInMode;

    switch (mode) {
      case WeekViewName:
        daysInMode = 7;
        break;
      case ThreeDaysViewName:
        daysInMode = 3;
        break;
      case BiweeklyViewName:
        daysInMode = 14;
        break;
    }
    const firstDay = currentViewStartDate;
    const lastDay = addDays(firstDay, daysInMode);
    return this.uncommittedChangePayload.some(e => {
      const changeDate = new Date(e.date);
      return isWithinInterval(changeDate, { start: firstDay, end: lastDay });
    });
  }
  /* event availiabity data section start */
  populateAvailability(data, weekStartDate) {
    weekStartDate.setHours(0, 0, 0, 0)
    // * Grab the response and display the availability on the calendar
    const _responseData = data;
    let _data = [];
    let eventStartDates = [];
    const firstDayofCurrentView = weekStartDate;
    // * Populate dates available
    _responseData.dateAvailable.forEach((availability) => {
      const _timeAvailable = availability.timeAvailable;

      // * Goes through all time availability.  Can have more than 1
      _timeAvailable.forEach((timeAvailable) => {
        // * Gets the first time stamp of an event
        let isEventRecorded = false;
        eventStartDates.forEach((eventStartDate) => {
          if (eventStartDate.eventID === timeAvailable.availableId) {
            isEventRecorded = true;
          }
        });

        if (!isEventRecorded) {
          eventStartDates.push({
            eventID: timeAvailable.availableId,
            eventStartDate: availability.date,
          });
        }

        const timeStart = timeAvailable.timeStart.substring(0, 5);
        const timeEnd = timeAvailable.timeEnd.substring(0, 5);
        const startDate = new Date(availability.date);
        const formattedStartDate = format(startDate, "yyyy-MM-dd");

        const endDate =
          timeAvailable.repeat === null
            ? startDate
            : new Date(timeAvailable.repeat.dateEffectiveTo);
        const formattedEndDate = format(endDate, "yyyy-MM-dd");
        // * Determine how long is the effective availability (for non-recurring events)
        if (startDate.getTime() >= firstDayofCurrentView.getTime()) {
          _data.push({
            eventID: timeAvailable.availableId,
            text:
              timeAvailable.pagingName === null
                ? "All paging groups"
                : timeAvailable.pagingName,
            pagingName:
              timeAvailable.pagingName === null
                ? "All paging groups"
                : timeAvailable.pagingName.replace(/_/g, " "),
            pagingNumber: timeAvailable.pagingNumber,
            start_date: `${formattedStartDate} ${timeStart}`,
            end_date: `${formattedStartDate} ${timeEnd}`,
            effective_end_date:
              timeAvailable.repeat === null
                ? null
                : `${formattedEndDate} ${timeStart}`,
            dayOfWeek:
              timeAvailable.repeat === null
                ? []
                : timeAvailable.repeat.dayOfWeek,
            available: true,
            availabilityTypes: timeAvailable.availabilityTypes,
            eventType: timeAvailable.availabilityTypes,
            type: timeAvailable.type,
          });
        }
      });
    });

    // * Populate dates unavailable
    if (_responseData.dateUnavailable) {
      _responseData.dateUnavailable.forEach((unavailability) => {
        const _timeUnvailable = unavailability.timeUnavailable;

        // * Goes through all time unavailability.  Can have more than 1
        _timeUnvailable.forEach((timeUnavailable) => {
          const timeStart = timeUnavailable.timeStart.substring(0, 5);
          const timeEnd = timeUnavailable.timeEnd.substring(0, 5);

          const startDate = new Date(unavailability.date);
          const formattedStartDate = format(startDate, "yyyy-MM-dd");

          const endDate =
            timeUnavailable.repeat === null
              ? startDate
              : new Date(timeUnavailable.repeat.dateEffectiveTo);
          const formattedEndDate = format(endDate, "yyyy-MM-dd");

          // * Determine how long is the effective unavailability (for non-recurring events)
          if (startDate.getTime() >= firstDayofCurrentView.getTime()) {
            _data.push({
              date: unavailability.date,
              eventID: timeUnavailable.unavailableId,
              text:
                timeUnavailable.pagingName === null
                  ? "Unavailable"
                  : timeUnavailable.pagingName.replace(/_/g, " "),
              pagingName:
                timeUnavailable.pagingName === null
                  ? "All paging groups"
                  : timeUnavailable.pagingName,
              pagingNumber: timeUnavailable.pagingNumber,
              start_date: `${formattedStartDate} ${timeStart}`,
              end_date: `${formattedStartDate} ${timeEnd}`,
              effective_end_date:
                timeUnavailable.repeat === null
                  ? null
                  : `${formattedEndDate} ${timeStart}`,
              dayOfWeek:
                timeUnavailable.repeat === null
                  ? []
                  : timeUnavailable.repeat.dayOfWeek,
              available: false,
              availabilityTypes: timeUnavailable.unavailabilityTypes,
              eventType: ["Unavailable"],
              type: timeUnavailable.type,
            });
          }
        });
      });
    }

    // * Assign Event Start Dates to all existing events
    _data.forEach((dataElement) => {
      eventStartDates.forEach((eventStartDate) => {
        if (dataElement.eventID === eventStartDate.eventID) {
          dataElement.event_start_date = format(
            new Date(eventStartDate.eventStartDate),
            this.getBrowserClient() === "Safari" ? "dd-MM-yyyy" : "yyyy-MM-dd"
          );
        }
      });
    });
    // * Pass in the data

    const selectedPagingGroup = this.props.selectedPagingGroups;
    const _dataPagingGroup = _data // only availabilities matching the currently selected paging group are displayed
      .filter(event => event.pagingNumber !== null)
      .filter(event => event.pagingNumber === selectedPagingGroup);
    scheduler.parse(_dataPagingGroup, "json");
  }

  getBrowserClient() {
    // * gets the browser name as the device name
    let Sys = {};
    let ua = navigator.userAgent.toLowerCase();
    var s = ua.match(/msie ([\d.]+)/)
      ? // eslint-disable-next-line no-use-before-define
      (Sys.ie = s[1])
      : // eslint-disable-next-line
      (s = ua.match(/firefox\/([\d.]+)/))
        ? // eslint-disable-next-line no-use-before-define
        (Sys.firefox = s[1])
        : // eslint-disable-next-line
        (s = ua.match(/chrome\/([\d.]+)/))
          ? // eslint-disable-next-line no-use-before-define
          (Sys.chrome = s[1])
          : // eslint-disable-next-line
          (s = ua.match(/opera.([\d.]+)/))
            ? // eslint-disable-next-line no-use-before-define
            (Sys.opera = s[1])
            : // eslint-disable-next-line
            (s = ua.match(/version\/([\d.]+).*safari/))
              ? // eslint-disable-next-line no-use-before-define
              (Sys.safari = s[1])
              : 0;
    let browserVersion = null;
    if (Sys.ie) {
      browserVersion = "IE";
    } else if (Sys.firefox) {
      browserVersion = "Firefox";
    } else if (Sys.chrome) {
      browserVersion = "Chrome";
    } else if (Sys.opera) {
      browserVersion = "Opera";
    } else if (Sys.safari) {
      browserVersion = "Safari";
    }
    return browserVersion;
  }

  createEvent = (details) => {
    return {
      pagingNumber: details.pagingNumber,
      start_date: `${details.dateFrom} ${details.timeStart}`,
      end_date: `${details.dateTo} ${details.timeEnd}`,
      dayOfWeek: details.daysOfWeek,
      availabilityTypes: details.availabilityTypes,
      eventType: details.availabilityTypes,
      currentDate: details.dateFrom
    };
  }
  onSaveEvent(newAvailability) {
    this.addEvent(newAvailability)
  }

  /**
  * Displays a toaster on the lower left of the screen
  * @param {String} message Message to be displayed in the toaster
  * @param {String} type Type of toaster (info, error, warning, success)
  */
  toastie = (message = "Hello world!", type = "info") => {
    mdtoast(message, {
      duration: 5000,
      type: type,
      interaction: false,
    });
  };

  deleteAvailability = (event) => {
    const API_ENDPOINT = event.available ?
      this.Requests.removeSingleAvailability :
      this.Requests.removeSingleUnavailability;

    this.Requests.callAPI(API_ENDPOINT, event.eventID).then((data) => {
      if (data?.status !== 200) {
        this.toastie(
          `Oops! Something went wrong! (${data.status} - ${data.statusText})`,
          "error"
        )
      }
    })
  }
  deleteEventsInRangeByView = (eventDate = null) => {
    return new Promise((resolve) => {
      const { firstDay, lastDay } = this.getFirstLastDayOfCurrentView(eventDate);
      lastDay.setDate(lastDay.getDate() + 1);
      const eventsInRange = scheduler.getEvents(firstDay, lastDay);
      if (eventsInRange.length === 0) {
        resolve();
      } else {
        eventsInRange.forEach((e) => {
          scheduler.deleteEvent(e.id);
        });
        resolve();
      }
    });
  };
  async getAvailabilityByView(isLoadingEvents = false, eventDate = null) {
    const loader = <div className="loader-container"><Loader /></div>;
    const { firstDay, lastDay } = this.getFirstLastDayOfCurrentView(eventDate);
    const dates = {
      dateFrom: format(firstDay, "yyyy-MM-dd"),
      dateTo: format(lastDay, "yyyy-MM-dd"),
    };
    // check for uncommitted changes first
    const isUncommittedChangesInWeek = this.isUncommittedInCurrentView();
    if (isLoadingEvents || !isUncommittedChangesInWeek) {
      try {
        this.setState({ isComponentLoading: true });
        const data = await this.Requests.callAPI(this.Requests.getUsersAvailability, dates);
        if (data?.status === 200) {
          await this.deleteEventsInRangeByView(eventDate);
          this.populateAvailability(data.data, firstDay);
        }
      } catch (error) {
        console.error('Error fetching availability:', error);
      } finally {
        this.setState({ isComponentLoading: false });
      }
    }
  }
  isUncommittedChangesInWeek(weekStart) {
  }
  convertMinutesToPercentage(minutes) {
    // Calculate the percentage (1 to 100)
    const percentage = (minutes / 60) * 100;
    return Math.round(percentage);
  }
  getWeekdayNumbers(dates) {
    return dates.map(date => {
      const parsedDate = new Date(date);
      return parsedDate.getDay(); // Gets the day of the week (0-6)
    });
  }
  compareTime(dateA, dateB) {
    const hoursA = dateA.getHours();
    const minutesA = dateA.getMinutes();

    const hoursB = dateB.getHours();
    const minutesB = dateB.getMinutes();

    // Compare hours
    if (hoursA < hoursB) {
      return -1; // dateA is earlier
    } else if (hoursA > hoursB) {
      return 1; // dateA is later
    } else {
      // If hours are the same, compare minutes
      if (minutesA < minutesB) {
        return -1; // dateA is earlier
      } else if (minutesA > minutesB) {
        return 1; // dateA is later
      } else {
        return 0; // times are equal
      }
    }
  }
  setupCustomBiWeeklyView = () => {
    //biweekly custom view setup
    scheduler.date.biweekly_start = scheduler.date.week_start;
    scheduler.templates.biweekly_date = scheduler.templates.week_date;
    scheduler.templates.biweekly_scale_date = scheduler.templates.week_scale_date;
    scheduler.date.add_biweekly = function (date, inc) { return scheduler.date.add(date, inc * 14, "day"); }
    scheduler.date.get_biweekly_end = function (date) { return scheduler.date.add(date, 14, "day"); }
    // 3 days custom view setup
    scheduler.date.multidays_start = function (date) {
      return scheduler.date.day_start(date);
    };
    scheduler.templates.multidays_date = scheduler.templates.week_date;
    scheduler.templates.multidays_scale_date = scheduler.templates.week_scale_date;
    scheduler.date.add_multidays = function (date, inc) { return scheduler.date.add(date, inc * 3, "day"); }
    scheduler.date.get_multidays_end = function (date) { return scheduler.date.add(date, 3, "day"); }
  }
  getDateStrFromDate = (dateObject) => {
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(dateObject.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
  }
  clearHighlightsTimeSlots = () => {
    // Clear previous highlights
    const allTimeSlotDivs = document.querySelectorAll(
      '.multidays-timeslots-style-left, .multidays-timeslots-style-right, .multidays-timeslots-style-top, .multidays-timeslots-style-bottom'
    );
    allTimeSlotDivs.forEach(div => {
      div.classList.remove(
        'multidays-timeslots-style-left',
        'multidays-timeslots-style-right',
        'multidays-timeslots-style-top',
        'multidays-timeslots-style-bottom'
      );
    });
  }
  highlightSelectedTimeSlots = (startTime, endTime) => {
    // Clear previous highlights
    this.clearHighlightsTimeSlots();
    const dateSlots = [];
    const timeSlots = [];
    let startHour = startTime.getHours();
    let startMinute = startTime.getMinutes();
    let endHour = endTime.getHours();
    let endMinute = endTime.getMinutes();
    let currentHour = startHour;
    let currentMinute = startMinute;
    let currentDate = new Date(startTime);
    // record time in 30 minute slots array
    if (startHour > endHour || (startHour === endHour && startMinute > endMinute)) {
      // Loop backwards if start time is after end time
      while (currentHour > endHour || (currentHour === endHour && currentMinute > endMinute)) {
        if (currentHour === 23 && currentMinute === 30) {
          const timeSlot = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
          if (!timeSlots.includes(timeSlot)) {
            timeSlots.push(timeSlot);
          }
        }
        if (currentMinute === 30) {
          currentMinute = 0;
        } else if (currentMinute === 0) {
          if (currentHour === 0) {
            currentMinute = 30;
          } else {
            currentHour -= 1;
            currentMinute = 30;
          }
        }
        const timeSlot = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
        timeSlots.push(timeSlot);
        this.setState({ selectedTimeSlots: timeSlots });
      }
    } else {
      // Loop forwards if start time is before end time
      while (currentHour < endHour || (currentHour === endHour && currentMinute <= endMinute)) {
        const timeSlot = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
        timeSlots.push(timeSlot);
        this.setState({ selectedTimeSlots: timeSlots });
        currentMinute += 30;
        if (currentMinute >= 60) {
          currentMinute = 0;
          currentHour += 1;
        }
      }
    }
    // record selected date in date array
    if (startTime > endTime) {
      // Loop backwards if start date-time is after end date-time
      let currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59);
      while (currentDateOnly >= endTime) {
        const dateSlot = this.getDateStrFromDate(currentDateOnly);
        if (!dateSlots.includes(dateSlot)) {
          dateSlots.push(dateSlot);
          this.setState({ selectedDateSlots: dateSlots });
        }
        currentDateOnly.setDate(currentDateOnly.getDate() - 1);
      }
    } else {
      let currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      while (currentDateOnly <= endTime) {
        const dateSlot = this.getDateStrFromDate(currentDateOnly);
        if (!dateSlots.includes(dateSlot)) {
          dateSlots.push(dateSlot);
          this.setState({ selectedDateSlots: dateSlots });
        }
        currentDateOnly.setDate(currentDateOnly.getDate() + 1);
      }
    }
    //applying css border to selected timeslots accordingly
    let startDate = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate());
    let endDate = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate());
    for (const dateIndex in dateSlots) {
      for (const timeIndex in timeSlots) {
        const dateIndexInt = parseInt(dateIndex, 10);
        const timeIndexInt = parseInt(timeIndex, 10);
        const slotDateString = dateSlots[dateIndexInt] + " " + timeSlots[timeIndexInt];
        if (startHour > endHour || (startHour === endHour && startMinute > endMinute)) {

          if (startDate > endDate) {
            //add bottom border
            if (timeIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-bottom')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-bottom');
              }
            }
            //add top border
            if (timeIndexInt === timeSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-top')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-top');
              }
            }
            //add right border
            if (dateIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-right')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-right');
              }
            }
            //add left border
            if (dateIndexInt === dateSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-left')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-left');
              }
            }
          } else { //top right
            //add bottom border
            if (timeIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-bottom')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-bottom');
              }
            }
            //add top border
            if (timeIndexInt === timeSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-top')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-top');
              }
            }
            //add right border
            if (dateIndexInt === dateSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-right')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-right');
              }
            }
            //add left border
            if (dateIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-left')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-left');
              }
            }
          }
        } else { ///dragging from top to bottom
          if (startDate > endDate) {
            //add bottom border
            if (timeIndexInt === timeSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-bottom')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-bottom');
              }
            }
            //add top border
            if (timeIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-top')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-top');
              }
            }
            //add right border
            if (dateIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-right')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-right');
              }
            }
            //add left border
            if (dateIndexInt === dateSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-left')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-left');
              }
            }
          } else {
            //add bottom border
            if (timeIndexInt === timeSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-bottom')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-bottom');
              }
            }
            //add top border
            if (timeIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-top')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-top');
              }
            }
            //add right border
            if (dateIndexInt === dateSlots.length - 1) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-right')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-right');
              }
            }
            //add left border
            if (dateIndexInt === 0) {
              const querystr = `div[data-slot-date="${slotDateString}"]`;
              const timeSlotDiv = document.querySelector(querystr);
              if (timeSlotDiv && !timeSlotDiv.classList.contains('multidays-timeslots-style-left')) {
                timeSlotDiv.classList.add('multidays-timeslots-style-left');
              }
            }
          }

        }
      }
    }
  }
  containDualAvailiablities(eventsInInterval) {
    for (let i = 0; i < eventsInInterval.length; i++) {
      for (let j = i + 1; j < eventsInInterval.length; j++) {
        const eventOne = eventsInInterval[i];
        const eventTwo = eventsInInterval[j];
        if (eventOne.start_date < eventTwo.end_date && eventOne.end_date > eventTwo.start_date) {
          return true; // there is a dual availability exists
        }
      }
    }
    return false; // No dual availability
  }
  shortRecurrentOverride = (newEvent, eventsInInterval) => {
    // there should be only one event type in eventType property, even it's an array type
    eventsInInterval.forEach((event) => {
      let startInInterval = event.start_date >= newEvent.start_date;
      let endInInterval = event.end_date <= newEvent.end_date;
      const currentEventCopy = JSON.parse(JSON.stringify(event));
      currentEventCopy.start_date = new Date(event.start_date);
      currentEventCopy.end_date = new Date(event.end_date);
      const isEmergencyAvailiable = (event.eventType.includes('Emergency') && newEvent.eventType.includes('Available')) || (event.eventType.includes('Available') && newEvent.eventType.includes('Emergency'));
      const hasUnavailable = (event.eventType.includes('Unavailable')) || (newEvent.eventType.includes('Unavailable'))
      // Case 1: Start not in, end in
      if (!startInInterval && endInInterval) {
        if (newEvent.eventType[0] === event.eventType[0] || isEmergencyAvailiable || hasUnavailable) {
          currentEventCopy.end_date = new Date(newEvent.start_date);
        }
        scheduler.getEvent(event.id).start_date = currentEventCopy.start_date;
        scheduler.getEvent(event.id).end_date = currentEventCopy.end_date;
        this.updateEvent(event);
      }
      // Case 2: Start in, end not in
      else if (startInInterval && !endInInterval) {
        if (newEvent.eventType[0] === event.eventType[0] || isEmergencyAvailiable || hasUnavailable) {
          currentEventCopy.start_date = new Date(newEvent.end_date);
        }
        scheduler.getEvent(event.id).start_date = currentEventCopy.start_date;
        scheduler.getEvent(event.id).end_date = currentEventCopy.end_date;
        this.updateEvent(event);
      }
      // Case 3: Event contains delete envelope
      else if (!startInInterval && !endInInterval) {
        if ((event.eventType[0] !== newEvent.eventType[0]) || isEmergencyAvailiable || hasUnavailable) {
          this.deleteEvent(event);
          const firstSectionAfterSplit = {
            start_date: event.start_date,
            end_date: newEvent.start_date,
            eventType: event.eventType,
            availabilityTypes: event.eventType,
            pagingNumber: event.pagingNumber,
            isUnavailable: event.eventType.includes('Unavailable')
          };
          this.addEvent(firstSectionAfterSplit);
          const lastSectionAfterSplit = {
            start_date: newEvent.end_date,
            end_date: event.end_date,
            eventType: event.eventType,
            availabilityTypes: event.availabilityTypes,
            pagingNumber: event.pagingNumber,
            isUnavailable: event.eventType.includes('Unavailable')
          }
          this.addEvent(lastSectionAfterSplit);
        }
      } else {
        // Case 4: new event overlaps with existing events, need to remove existing events - startInInterval : true endInInterval : true
        this.deleteEvent(event);
      }
    })
  }
  processAvailabilityEvents = (availabilityEvents, eventID, numberOfType) => {
    if (numberOfType > 0) {
      availabilityEvents.map((availabilityEvent) => {
        const start = availabilityEvent.start_date;
        const end = availabilityEvent.end_date;
        const eventsInInterval = scheduler.getEvents(start, end);
        const numOfExistingEvents = eventsInInterval.length;
        const isEmergencyAvailiable = eventsInInterval.some(event => {
          return (event.eventType.includes('Emergency') && availabilityEvent.eventType.includes('Available')) ||
            (event.eventType.includes('Available') && availabilityEvent.eventType.includes('Emergency'));
        });
        const isSameType = eventsInInterval.some(e => e.eventType[0] === availabilityEvent.eventType[0]);
        const hasUnavailable = availabilityEvent.eventType.includes('Unavailable') || eventsInInterval.some(event => event.eventType.includes('Unavailable'));
        if ((numberOfType === 2 && numOfExistingEvents >= 1) ||
          (numberOfType === 1 && numOfExistingEvents >= 2 && (this.containDualAvailiablities(eventsInInterval) || isSameType)) ||
          (numberOfType === 1 && numOfExistingEvents === 1 && (isEmergencyAvailiable || isSameType)) ||
          (hasUnavailable)) {
          // conflicts, override the existing event, delete or resize existing events
          this.shortRecurrentOverride(availabilityEvent, eventsInInterval);
        }
      });
      availabilityEvents.map((event) => {
        this.onSaveEvent(event);
      });
    } else {
      availabilityEvents.map((availabilityEvent) => {
        // get all events in the dragged interval
        const start = availabilityEvent.start_date;
        const end = availabilityEvent.end_date;
        const eventsInInterval = eventID ? scheduler.getEvents(start, end).filter((e) => e.id !== eventID) : scheduler.getEvents(start, end);
        const availabilityType = this.props.selectedAvailabilityType;

        switch (availabilityType) {
          case 'Delete':
            this.adjustExistingEventDualAvailability(availabilityEvent, eventsInInterval);
            break;
          case 'Unavailable':
            this.adjustExistingEventDualAvailability(availabilityEvent, eventsInInterval);
            this.addEvent(availabilityEvent);
            break;
          case 'Other':
          case 'Available':
          case 'Emergency':
            this.paintingOverrideNew(availabilityEvent, eventsInInterval);
            break;
          default:
            console.error(`Unhandled event type: ${availabilityEvent.eventType[0]}`);
        }
      });

    }

  }

  paintingOverrideNew = (newEvent, eventsInInterval) => {
    if (eventsInInterval.length === 0) {
      this.addEvent(newEvent);
    } else {
      if (!this.containDualAvailiablities(eventsInInterval)) {
        // allow creating dual availability scenarios, Other/Available or Other/Emergency
        const hasAvailableOrEmergency = eventsInInterval.some(e => e.eventType[0] === 'Available' || e.eventType[0] === 'Emergency');
        const hasUnavailable = eventsInInterval.some(e => e.eventType[0] === 'Unavailable');
        const hasOtherEventType = eventsInInterval.some(e => e.eventType[0] !== 'Available' && e.eventType[0] !== 'Emergency' && e.eventType[0] !== 'Unavailable');
        if (newEvent.eventType[0] === 'Other' && hasAvailableOrEmergency && !hasUnavailable) {
          this.addEvent(newEvent);
          // Delete all events with eventType "Other"
          eventsInInterval.forEach(e => {
            if (e.eventType[0] === 'Other') {
              this.deleteEvent(e);
            }
          });
        } else if ((newEvent.eventType[0] === 'Available' || newEvent.eventType[0] === 'Emergency') && hasOtherEventType) {
          this.addEvent(newEvent);
          // Delete all events with eventType "Available" or "Emergency"
          eventsInInterval.forEach(e => {
            if (e.eventType[0] === 'Available' || e.eventType[0] === 'Emergency') {
              this.deleteEvent(e);
            }
          });
        } else if (eventsInInterval.every(e => e.eventType[0] === newEvent.eventType[0])) {
          //if it has same event type, Get the earliest start_date and latest end_date
          let earliestStartDate = new Date(newEvent.start_date);
          let latestEndDate = new Date(newEvent.end_date);
          eventsInInterval.forEach(e => {
            if (new Date(e.start_date) < earliestStartDate) {
              earliestStartDate = new Date(e.start_date);
            }
            if (new Date(e.end_date) > latestEndDate) {
              latestEndDate = new Date(e.end_date);
            }
          });
          // Remove all events from eventsInInterval
          eventsInInterval.forEach(e => {
            this.deleteEvent(e);
          });
          const mergedEvent = {
            ...newEvent,
            start_date: earliestStartDate,
            end_date: latestEndDate
          };
          this.addEvent(mergedEvent);
        } else {
          this.overrideExistingEvent(newEvent, eventsInInterval);
        }
      } else {
        this.adjustExistingEventDualAvailability(newEvent, eventsInInterval);
        this.addEvent(newEvent);
      }
      // end of creating dual availability scenarios

    }

  }
  overrideExistingEvent = (newEvent, eventsInInterval) => {
    eventsInInterval.forEach((event) => {
      let startInInterval = new Date(event.start_date) >= new Date(newEvent.start_date);
      let endInInterval = new Date(event.end_date) <= new Date(newEvent.end_date);
      // emergency, other and availble override logics
      if (startInInterval && !endInInterval) {
        if (newEvent.eventType[0] === event.eventType[0]) {
          event.start_date = newEvent.start_date;
        } else {
          event.start_date = newEvent.end_date;
          this.addEvent(newEvent);
        }
        this.updateEvent(event);
      } else if (!startInInterval && endInInterval) {
        if (newEvent.eventType[0] === event.eventType[0]) {
          event.end_date = newEvent.end_date;
        } else {
          event.end_date = newEvent.start_date;
          this.addEvent(newEvent);
        }
        this.updateEvent(event);
      } else if (startInInterval && endInInterval) {
        // new event covers the existing event
        this.deleteEvent(event);
        this.addEvent(newEvent);
      } else {
        // new event is in the middle of an existing event
        if (event.eventType[0] !== newEvent.eventType[0]) {
          this.deleteEvent(event);
          const firstSectionAfterSplit = {
            start_date: event.start_date,
            end_date: newEvent.start_date,
            eventType: event.eventType,
            availabilityTypes: event.eventType,
            pagingNumber: event.pagingNumber,
            isUnavailable: event.eventType.includes('Unavailable')
          };
          this.addEvent(firstSectionAfterSplit);
          if (newEvent.eventType[0] !== event.eventType[0]) {
            const newMiddleEvent = {
              start_date: newEvent.start_date,
              end_date: newEvent.end_date,
              eventType: newEvent.eventType,
              availabilityTypes: newEvent.availabilityTypes,
              pagingNumber: newEvent.pagingNumber,
              isUnavailable: newEvent.eventType.includes('Unavailable')
            };
            this.addEvent(newMiddleEvent);
          }
          const lastSectionAfterSplit = {
            start_date: newEvent.end_date,
            end_date: event.end_date,
            eventType: event.eventType,
            availabilityTypes: event.availabilityTypes,
            pagingNumber: event.pagingNumber,
            isUnavailable: event.eventType.includes('Unavailable')
          }
          this.addEvent(lastSectionAfterSplit);
        }
      }
    });
  }
  adjustExistingEventDualAvailability = (newEvent, eventsInInterval) => {
    eventsInInterval.forEach((event) => {
      let startInInterval = new Date(event.start_date) >= new Date(newEvent.start_date);
      let endInInterval = new Date(event.end_date) <= new Date(newEvent.end_date);
      // emergency, other and availble override logics
      if (startInInterval && !endInInterval) {
        event.start_date = newEvent.end_date;
        this.updateEvent(event);
      } else if (!startInInterval && endInInterval) {
        event.end_date = newEvent.start_date;
        this.updateEvent(event);
      } else if (startInInterval && endInInterval) {
        // new event covers the existing event
        this.deleteEvent(event);
      } else {
        // new event is in the middle of an existing event
        this.deleteEvent(event);
        const firstSectionAfterSplit = {
          start_date: event.start_date,
          end_date: newEvent.start_date,
          eventType: event.eventType,
          availabilityTypes: event.eventType,
          pagingNumber: event.pagingNumber,
          isUnavailable: event.eventType.includes('Unavailable')
        };
        this.addEvent(firstSectionAfterSplit);
        const lastSectionAfterSplit = {
          start_date: newEvent.end_date,
          end_date: event.end_date,
          eventType: event.eventType,
          availabilityTypes: event.availabilityTypes,
          pagingNumber: event.pagingNumber,
          isUnavailable: event.eventType.includes('Unavailable')
        }
        this.addEvent(lastSectionAfterSplit);
      }
    });
  }
  /* event availiabity data section end*/
  schedulerConfig() {
    scheduler.skin = 'material';
    scheduler.plugins({
      recurring: true,
      limit: true,
      minical: true,
    });
    scheduler.config.undo_deleted = false;
    scheduler.config.multi_day = false;
    scheduler.config.drag_create = true;
    scheduler.config.time_step = 30;
    scheduler.config.dblclick_create = false;
    scheduler.config.drag_move = false; //enable/disable event move
    scheduler.config.select = false; //shows/hides the tool box bar in the event's box
    scheduler.config.drag_event_body = false;
    scheduler.config.drag_resize = false;
    scheduler.config.undo_deleted = false;
    scheduler.config.touch_drag = 100;
    scheduler.config.touch_tip = false;
    scheduler.config.touch_tooltip = false;
    scheduler.locale.labels.biweekly_tab = BiweeklyViewName;
    scheduler.locale.labels.threedays_tab = ThreeDaysViewName;
    scheduler.config.mark_now = false; // remove the current time marker
    scheduler.showLightbox = () => false;
    // * Assign proper class styling on events
    scheduler.templates.event_class = (start, end, event) => {
      let _cssClass = "";

      // * Assign proper class for event type
      if (event.eventType !== undefined) {
        if (event.eventType.includes("Available")) {
          _cssClass += '-available'
        }

        else if (event.eventType.includes("Emergency")) {
          _cssClass += "-emergency ";
        }

        else if (event.eventType.includes("Non-Emergency")) {
          _cssClass += "-non-emergency ";
        }

        else if (event.eventType.includes("Unavailable")) {
          _cssClass += "-unavailable ";
        }

        else if (event.eventType.includes("Other")) {
          _cssClass += "-other ";
        }

      }
      else {
        _cssClass += "undefined"
      }

      return _cssClass.trim();
    };
    scheduler.renderEvent = (container, event) => {
      const { isMobilePortrait, selectedViewType } = this.state;
      const isBiWeeklyView = selectedViewType === BiweeklyViewName;
      const isThreeDaysView = selectedViewType === ThreeDaysViewName;
      const parentWidth = parseInt(container.style.width, 10);
      const currentLeft = parseFloat(container.style.left);
      const leftPaddingRatio = isMobilePortrait ? 0.85 : 0.95;
      const eventWidth = Math.max(10, parentWidth * leftPaddingRatio); // Example: 80% of window width with a minimum of 200px
      // Get events in the same time range
      const eventsInSameTimeRange = scheduler.getEvents(event.start_date, event.end_date);
      const eventCount = eventsInSameTimeRange.length;
      container.style.width = `${eventWidth}px`;
      // Determine if the current event is the leftmost or rightmost
      const isLeftEvent = currentLeft === 1;
      const isRightEvent = currentLeft > 1;
      // Calculate the dynamic left offset based on window size
      const windowWidth = window.innerWidth;
      // Define breakpoints for different resolutions
      const isSmallTable = windowWidth <= 600;
      const isMediumTable = windowWidth > 600 && windowWidth <= 1024;
      const isLargeTable = windowWidth > 1024;
      let singleEventRatio;
      let doubleEventsRatio;
      if (isMobilePortrait) {
        singleEventRatio = 0.24;
        doubleEventsRatio = 0.55;
      } else if (isSmallTable) {
        singleEventRatio = 0.10;
        doubleEventsRatio = 0.20;
      } else if (isMediumTable) {
        singleEventRatio = 0.08;
        doubleEventsRatio = 0.16;
      } else if (isLargeTable) {
        singleEventRatio = 0.05;
        doubleEventsRatio = 0.1;
      } else {
        // Default ratios for any other cases
        singleEventRatio = 0.05;
        doubleEventsRatio = 0.10;
      }
      // Adjust ratios based on the view type
      if (isBiWeeklyView) {
        singleEventRatio *= 1.8;
        doubleEventsRatio *= 1.8;
      } else if (isThreeDaysView) {
        singleEventRatio /= 1.5;
        doubleEventsRatio /= 1.5;
      }
      const dynamicOffset = eventCount > 1 ? eventWidth * doubleEventsRatio : eventWidth * singleEventRatio;
      // Set the left position directly
      let leftValue;
      if (eventCount > 1) {
        if (isLeftEvent) {
          leftValue = dynamicOffset;
        } else if (isRightEvent) {
          leftValue = eventWidth + dynamicOffset;
        }
      } else {
        leftValue = dynamicOffset;
      }
      // Set the left position directly
      container.style.left = `${leftValue}px`;
      // Create the HTML structure for the event
      let _html = `
          <div class="dhx_body"></div>
      `;
      container.setAttribute("role", "gridcell");
      // Passes it into the DOM
      container.innerHTML = _html;

      // Required, true - to display a custom form, false - the default form
      return true;
    };
    scheduler.date[ThreeDaysViewName] = function (date) {
      var ndate = new Date(date.valueOf());
      ndate.setDate(ndate.getDate() + 3);
      return ndate;
    };
    scheduler.templates.event_date = function (date) {
      var endHour = date.getHours();
      var endMinutes = ("0" + date.getMinutes()).slice(-2);
      return endHour + ":" + endMinutes;
    };
    scheduler.templates.time_slot_class = function (date) {
      const minutes = date.getMinutes();
      // Add the half-hour border class to the half-hour slots
      if (minutes === 30) {
        return "dhx_matrix_cell_halfhour_border";
      }
    };
    scheduler.templates.week_date_class = function (date, today) {
      const mode = scheduler.getState().mode;
      // get the day of the week (0 is Sunday, 1 is Monday, etc.)
      const day = date.getDay();

      if (mode === WeekViewName && (day === 2 || day === 4 || day === 6)) {
        return "cells_bgColorCustom";
      }
      if (mode === BiweeklyViewName) {
        const startDate = scheduler.getState().min_date;
        const dayDifference = Math.floor((date - startDate) / (1000 * 60 * 60 * 24));
        if (dayDifference % 14 === 6) { // Check if it's the 7th day
          return "cells_borderRightCustom";
        }
        if (dayDifference % 2 - 1 === 0) {
          return "cells_bgColorCustom";
        }
      }
      if (mode === ThreeDaysViewName) {
        const startDate = scheduler.getState().min_date;
        const endDate = scheduler.getState().max_date;
        const middleDate = new Date((startDate.getTime() + endDate.getTime()) / 2);
        if (date.getDate() === middleDate.getDate()) {
          return "cells_bgColorCustom";
        }
      }
      return "";
    };
    scheduler.templates.week_scale_date = this.schedulerSubHeaderContent;

    this.eventOnDrag = scheduler.attachEvent("onEventDrag", (id, mode, evt) => {
      // solving the odd custom background color issue on time scale 12th hour cell.
      const elements = document.getElementsByClassName('dhx_scale_hour');
      const targetElement = elements[elements.length - 12]; // Get the 13th element from the end
      if (targetElement && (!targetElement.getAttribute('timescale-background-fix') || targetElement.getAttribute('timescale-background-fix') === 'false')) {
        // Apply styles directly to the target element
        targetElement.style.position = 'relative';
        targetElement.style.overflow = 'hidden';
        targetElement.style.border = 'none';
        // Check if the after-element already exists
        let afterElement = targetElement.querySelector('.after-element');
        if (!afterElement) {
          // Create and append the ::after pseudo-element using a child div
          const afterElement = document.createElement('div');
          afterElement.className = 'after-element';
          afterElement.style.position = 'absolute';
          afterElement.style.bottom = '-50%';
          afterElement.style.left = '0';
          afterElement.style.right = '0';
          afterElement.style.height = '100%';
          afterElement.style.backgroundColor = 'rgba(217, 217, 217, 0.2)';
          afterElement.style.zIndex = '10';
          targetElement.appendChild(afterElement);
        } else {
          afterElement.style.backgroundColor = 'rgba(217, 217, 217, 0.2)';
        }
        // Set a custom attribute to indicate that the styles have been added
        targetElement.setAttribute('timescale-background-fix', 'true');
      }
      // finsihsed solving the odd custom background color issue on time scale 12th hour cell.
      const event = scheduler.getEvent(id);
      let startEndDatetime = event.end_date;
      let start = event.start_date;
      const end = scheduler.getActionData(evt).date;
      const backward = this.compareTime(start, end);
      // get hour/minute part for `zones` calculation *backward creation

      if (backward != -1) {
        // add code if start date time is 23:30 to 00:00 - fixing edge case if user select last time slot of the day
        if (startEndDatetime.getMinutes() === 0 && startEndDatetime.getHours() === 0) {
          let endDate = new Date(startEndDatetime);
          endDate.setMinutes(endDate.getMinutes() - 30);
          start = endDate;
        } else {
          start = startEndDatetime;
        }
      }
      if (mode === "new-size") {
        if (!this.previousTimeSlot || this.previousTimeSlot.getTime() !== end.getTime()) {
          this.previousTimeSlot = end;
          this.highlightSelectedTimeSlots(start, end);
        }
      }
      return true;
    });
    this.eventTemplateReady = scheduler.attachEvent("onTemplatesReady", () => {
      this.setupCustomBiWeeklyView();
      if (!this.state.isMobilePortrait) {
        this.addOrRemoveTimeRow(true);
      }
      this.addUndoViewByDropdown();
    });
    this.eventOnBeforeDrag = scheduler.attachEvent("onBeforeDrag", (id, mode, event) => {
      if (mode === "new-size" || mode === "create") {
        const schedulerWrapper = document.getElementById('scheduler_wrapper');
        if (schedulerWrapper) {
          // Disable scrolling
          document.getElementById('scheduler_wrapper').style.overflow = 'hidden';
        }
      }
      return true;
    });
    this.eventOnDragEnd = scheduler.attachEvent("onDragEnd", (id, mode, event) => {
      const { selectedDateSlots, selectedTimeSlots } = this.state;
      // Clear previous highlights
      this.clearHighlightsTimeSlots();
      // remove the time scale background fix time scale 12th cell issue
      const dhxScaleHourElements = document.getElementsByClassName('dhx_scale_hour');
      for (let i = 0; i < dhxScaleHourElements.length; i++) {
        const targetElement = dhxScaleHourElements[i];
        const afterElement = targetElement.querySelector('.after-element');
        if (afterElement) {
          targetElement.setAttribute('timescale-background-fix', 'false');
          afterElement.style.backgroundColor = '';
        }
      }
      //remove the current event created by the scheulder
      if (!event.eventType) {
        scheduler.deleteEvent(id);
      }
      let validDrag = false;
      //create events when selectedAvailabilityType isn't null
      if (mode === "new-size" && selectedDateSlots && selectedDateSlots.length > 0 &&
        (this.props?.selectedAvailabilityType !== null)) {
        validDrag = true;
        if (this.undoStack.length === 0) {
          //reset redo if user start from scratch
          this.redoStack = [];
        } else {
          //remove actions from undoStack after undo index
          this.undoStack = this.undoStack.slice(0, this.state.undoIndex);
          this.redoStack = this.redoStack.slice(0, this.state.undoIndex);
        }
        let sortedTimesAscend = [];
        if (selectedTimeSlots && selectedTimeSlots.length > 0) {
          sortedTimesAscend = selectedTimeSlots.sort((a, b) => {
            const [hourA, minuteA] = a.split(':').map(Number);
            const [hourB, minuteB] = b.split(':').map(Number);
            return hourA - hourB || minuteA - minuteB;
          });
        }
        this.setState({
          isEditEvent: true,
          selectedFullDay: null
        })
        const [hours, minutes] = sortedTimesAscend[sortedTimesAscend.length - 1].split(':').map(Number);
        const ascendLastDate = new Date();
        ascendLastDate.setHours(hours);
        ascendLastDate.setMinutes(minutes);
        if (hours === 23 && minutes === 30) {
          // fixing 00:00 scenario 23:59
          ascendLastDate.setMinutes(ascendLastDate.getMinutes() + 29);
        } else {
          ascendLastDate.setMinutes(ascendLastDate.getMinutes() + 30);
        }
        const ascendLastDateStr = `${String(ascendLastDate.getHours()).padStart(2, '0')}:${String(ascendLastDate.getMinutes()).padStart(2, '0')}`;
        const availabilityEvents = selectedDateSlots.map(date => {
          const start_date = new Date(`${date} ${sortedTimesAscend[0]}`);
          const end_date = new Date(`${date} ${ascendLastDateStr}`);
          const eventType = [this.props.selectedAvailabilityType];
          const currentDate = date;
          const pagingNumber = this.props.selectedPagingGroups;
          return { start_date, end_date, eventType, currentDate, pagingNumber };
        });
        this.pushSnapshotToUndoRedoStack(this.undoStack, availabilityEvents, false, false);
        this.setState({ undoIndex: this.undoStack.length });
        this.processAvailabilityEvents(availabilityEvents, id, 0);
        // after changes, capture latest changes for redo stack
        this.pushSnapshotToUndoRedoStack(this.redoStack, availabilityEvents, true, false);
        this.setState({ redoIndex: this.redoStack.length });
      }
      const schedulerWrapper = document.getElementById('scheduler_wrapper');
      if (schedulerWrapper) {
        schedulerWrapper.style.overflow = '';
      } else {
        console.error('Element with ID scheduler_wrapper not found');
      }
      return validDrag;
    });
    scheduler.config.header = [];
    scheduler.xy.nav_height = 0; // remove the default header
    scheduler.init(this.schedulerContainer, new Date());
    this.attachEvents();
    this.eventViewChange = scheduler.attachEvent("onViewChange", (new_mode, new_date) => {
      this.attachEvents();
      const formatFunc = scheduler.date.date_to_str('%F %Y');
      const currentMonth = formatFunc(scheduler.getState().date);
      const currentMonthLabel = this.retrieveDocNode('.dhx_cal_current_month.carousel-month');
      if (currentMonthLabel)
        currentMonthLabel.textContent = currentMonth;
      currentMonthLabel?.parentNode.replaceChild(this.schedulerCurrentMonthHeader(currentMonth), currentMonthLabel);
      !this.state.isMobilePortrait && this.addUndoViewByDropdown();
      // sets role for dhx_scale_holder -- accessibility testing
      const schedulerSelector = document.getElementById('scheduler');
      schedulerSelector.setAttribute("role", "grid")

      const schedulerPrimaryChildren = document.querySelectorAll("#scheduler > *");
      schedulerPrimaryChildren.forEach((item) => {
        if (item.children.length > 0) {
          if (item.classList.contains("dhx_cal_data")) {
            item.setAttribute("role", "rowgroup");
          }
          else {
            item.setAttribute("role", "row");
          }
          Array.from(item.children)
            .filter((child) => child.nodeType === Node.ELEMENT_NODE)
            .forEach((item) => {
              if (item.classList.contains("dhx_scale_holder")) {
                item.setAttribute("role", "row");
              }
              else {
                item.setAttribute("role", "gridcell");
              }
            });
        }
      });
      document.querySelectorAll('.dhx_cal_event, .dhx_scale_time_slot, .dhx_scale_hour').forEach((item) => {
        item.setAttribute('role', 'gridcell');
      });
      this.props.addNotchSafePadding();
    });
    scheduler.clearAll();
    this.viewByValueChange(this.props.viewByRange)
  }
  componentWillUnmount() {
    scheduler.detachEvent(this.eventTemplateReady);
    scheduler.detachEvent(this.eventOnBeforeDrag);
    scheduler.detachEvent(this.eventViewChange);
    scheduler.detachEvent(this.eventOnDragEnd)
    scheduler.detachEvent(this.eventOnDrag)
    window.removeEventListener('resize', this.handleWindowResizeChange);
    //remove swipe event listeners
    const schedulerElement = document.querySelector('#scheduler');
    if (schedulerElement && schedulerElement.hasSwipeEventListeners) {
      schedulerElement.removeEventListener('touchstart', this.detectTouchStart);
      schedulerElement.removeEventListener('touchmove', this.detectTouchMove);
      schedulerElement.removeEventListener('touchend', this.detectTouchEnd);
      schedulerElement.hasSwipeEventListeners = false;
    }
  };
  componentDidMount() {
    this.schedulerConfig();
    this.updateSurroundingMonths();
    this.handleWindowResizeChange();
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setState({ windowHeight: window.innerHeight }, () => {
        this.props.addNotchSafePadding();
      })
    }, 100);
    this.viewByValueChange(this.props.viewByRange);
    window.addEventListener('resize', this.handleWindowResizeChange);
  }
  createEventsForDate(repeatDates, timeFrom, timeTo, availabilityTypes, pagingNumber, events) {
    const [timeFromHours, timeFromMinutes] = timeFrom.split(':').map(Number);
    const [timeToHours, timeToMinutes] = timeTo.split(':').map(Number);
    // Set time on date object
    const startDateTime = new Date(repeatDates);
    startDateTime.setHours(timeFromHours, timeFromMinutes, 0, 0);
    const endDateTime = new Date(repeatDates);
    endDateTime.setHours(timeToHours, timeToMinutes, 0, 0);
    const year = repeatDates.getFullYear();
    const month = String(repeatDates.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(repeatDates.getDate()).padStart(2, '0');
    const currentDate = `${year}-${month}-${day}`;
    availabilityTypes.forEach(availabilityType => {
      events.push({
        start_date: startDateTime,
        end_date: endDateTime,
        eventType: [availabilityType],
        currentDate: currentDate,
        pagingNumber: pagingNumber
      });
    });
    return events;
  }
  availabilityFormSubmitted = async () => {
    let {
      availabilityTypes,
      date,
      dateTo,
      timeFrom,
      timeTo,
      repeatCount,
      daysOfWeek,
      dateOfMonth,
      seriesType
    } = this.props.availabilityFormPayload
    const isUnavailable = availabilityTypes.includes('Unavailable')
    const isRcurrent = seriesType ? true : false;
    if (timeTo === '24:00') {
      timeTo = '23:59'
    }
    let availabilityEvents = [];
    if (isRcurrent) {
      const startDate = new Date(date);
      const endDate = new Date(dateTo);
      const events = [];
      if (seriesType && seriesType === 'Weekly') {
        const dayMap = {
          Sunday: 0,
          Monday: 1,
          Tuesday: 2,
          Wednesday: 3,
          Thursday: 4,
          Friday: 5,
          Saturday: 6
        };
        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
          const currentDay = d.getDay();
          const currentDayName = Object.keys(dayMap).find(key => dayMap[key] === currentDay);
          if (daysOfWeek.includes(currentDayName)) {
            availabilityEvents = this.createEventsForDate(d, timeFrom, timeTo, availabilityTypes, this.props.selectedPagingGroups, events);
          }
        }
      } else if (seriesType === 'Daily') {
        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
          availabilityEvents = this.createEventsForDate(d, timeFrom, timeTo, availabilityTypes, this.props.selectedPagingGroups, events);
        }
      } else if (seriesType === 'Monthly') {
        const dateOfMonthInt = parseInt(dateOfMonth, 10);
        for (let d = new Date(startDate); d <= endDate;) {
          const year = d.getFullYear();
          const month = d.getMonth();
          const lastDayOfMonth = new Date(year, month + 1, 0).getDate(); // Get the last day of the current month
          // Ensure dateOfMonth is valid for the current month
          if (dateOfMonthInt <= lastDayOfMonth) {
            const monthlyDate = new Date(year, month, dateOfMonthInt);
            if (monthlyDate >= startDate && monthlyDate <= endDate) {
              availabilityEvents = this.createEventsForDate(monthlyDate, timeFrom, timeTo, availabilityTypes, this.props.selectedPagingGroups, events);
            }
          }
          d.setMonth(month + 1);
          d.setDate(1);
        }
      }
    } else {
      availabilityEvents = availabilityTypes.map(availabilityType => {
        const start_date = new Date(`${date} ${timeFrom}`);
        const end_date = new Date(`${date} ${timeTo}`);
        const eventType = [availabilityType];
        const currentDate = date;
        const pagingNumber = this.props.selectedPagingGroups;
        return { start_date, end_date, eventType, currentDate, pagingNumber };
      });
    }
    // snap to view of changes
    const viewStart = scheduler.getState().min_date;
    const viewEnd = scheduler.getState().max_date;
    const startDateOfViews = this.getUniqueFirstDateEachView(availabilityEvents, viewStart);
    if ((new Date(date) < viewStart) || (new Date(date) > viewEnd)) {
      scheduler.setCurrentView(date)
      this.props.addNotchSafePadding();
      this.updateSurroundingMonths(new Date(date));
    }
    for (const startDate of startDateOfViews) {
      await this.getAvailabilityByView(true, startDate);
    }
    if (this.undoStack.length === 0) {
      //reset redo if user start from scratch
      this.redoStack = [];
    } else {
      //remove actions from undoStack after undo index
      this.undoStack = this.undoStack.slice(0, this.state.undoIndex);
      this.redoStack = this.redoStack.slice(0, this.state.undoIndex);
    }
    this.pushSnapshotToUndoRedoStack(this.undoStack, availabilityEvents, false, true)
    this.setState({ undoIndex: this.undoStack.length });
    this.processAvailabilityEvents(availabilityEvents, null, availabilityTypes.length);
    this.pushSnapshotToUndoRedoStack(this.redoStack, availabilityEvents, true, true);
    this.setState({ redoIndex: this.redoStack.length });
  }
  getUniqueFirstDateEachView = (availabilityEvents, currentViewStart) => {
    const uniqueMondays = new Set();
    const uniqueUncommittedMondays = new Set();
    this.uncommittedChangePayload.forEach((item) => {
      const uncommittedChangeDate = new Date(item.date);
      const mondayDate = startOfWeek(uncommittedChangeDate, { weekStartsOn: 1 });
      uniqueUncommittedMondays.add(mondayDate);
    });
    availabilityEvents.forEach((event) => {
      const eventDate = new Date(event.start_date);
      // Use date-fns to get the Monday of the week
      const mondayDate = startOfWeek(eventDate, { weekStartsOn: 1 }); // 1 = Monday
      // Add the Monday date to the Set
      if (mondayDate.getTime() !== currentViewStart.getTime()) {
        uniqueMondays.add(mondayDate); // Use timestamp for uniqueness
      }
    });
    const filteredMondays = new Set(
      Array.from(uniqueMondays).filter((monday) => {
        return !Array.from(uniqueUncommittedMondays).some(
          (uncommittedMonday) => monday.getTime() === uncommittedMonday.getTime()
        );
      })
    );

    // Convert the Set of timestamps back to Date objects
    return Array.from(filteredMondays).map((timestamp) => new Date(timestamp));
  };
  isNewOtherEventCovered = (newEvent, eventsInInterval) => {
    return newEvent.eventType === "Other" && eventsInInterval.some(event => {
      if (event.eventType === "Other") {
        const eventStart = new Date(event.start_date);
        const eventEnd = new Date(event.end_date);
        const newEventStart = new Date(newEvent.start_date);
        const newEventEnd = new Date(newEvent.end_date);

        return newEventStart >= eventStart && newEventEnd <= eventEnd;
      }
      return false;
    });
  };
  isNewEventCoveringAllEvents = (newEvent, eventsInInterval) => {
    const newEventStart = new Date(newEvent.start_date);
    const newEventEnd = new Date(newEvent.end_date);

    return eventsInInterval.every(event => {
      const eventStart = new Date(event.start_date);
      const eventEnd = new Date(event.end_date);
      return newEventStart <= eventStart && newEventEnd >= eventEnd;
    });
  };

  applyTemplate = () => {
    const viewStart = scheduler.getState().min_date
    const viewEnd = scheduler.getState().max_date
    const periodStart = startOfWeek(viewStart, { weekStartsOn: 1 })
    const availabilities = this.templateToAvailability(this.props.templateToApply, periodStart)
    const secondWeekStart = startOfWeek(subDays(viewEnd, 1), { weekStartsOn: 1 })
    const viewAcrossTwoWeeks = periodStart.getTime() !== secondWeekStart.getTime()
    if (viewAcrossTwoWeeks) {
      let secondWeekAvailabilities = this.templateToAvailability(this.props.templateToApply, secondWeekStart)
      secondWeekAvailabilities.forEach(event => availabilities.push(event))
    }
    if (this.undoStack.length === 0) {
      //reset redo if user start from scratch
      this.redoStack = [];
    } else {
      //remove actions from undoStack after undo index
      this.undoStack = this.undoStack.slice(0, this.state.undoIndex);
      this.redoStack = this.redoStack.slice(0, this.state.undoIndex);
    }
    // store the snapshot of the current state before changes, using isShortRecurrent true as it involve applying dual availability in one action
    this.pushSnapshotToUndoRedoStack(this.undoStack, availabilities, false, true);
    this.setState({ undoIndex: this.undoStack.length });

    // clear week and add events from template in
    const eventsToClear = scheduler.getEvents(viewStart, viewEnd)
    eventsToClear.forEach(e => scheduler.deleteEvent(e.id))
    availabilities.filter((e) => !e.eventType.includes('Delete')).forEach((e) => {
      // only add events in timerange
      if (e.start_date >= viewStart && e.end_date <= viewEnd) {
        this.addEvent(e)
      }
    })
    // capture latest changes for redo stack
    this.pushSnapshotToUndoRedoStack(this.redoStack, availabilities, true, true)
    this.setState({ redoIndex: this.redoStack.length })
  }
  componentDidUpdate(prevProps, prevState) {
    // check if availability form was submitted
    if (prevProps.availabilityFormPayload !== this.props.availabilityFormPayload) {
      // creates a snapshot
      this.availabilityFormSubmitted();
    }
    // check if view by range updated
    if (prevProps.viewByRange !== this.props.viewByRange) {
      this.viewByValueChange(this.props.viewByRange);
    }
    if (this.props.clearUncommittedChanges) {
      this.uncommittedChanges = [];
      this.uncommittedChangePayload = [];
      this.props.uncommittedChangesCleared();
    }

    // check if template should be applied
    if (prevProps.templateToApply !== this.props.templateToApply) {
      this.applyTemplate();
    }
    // Add padding after all updates
    if (this.props.addNotchSafePadding) {
      this.props.addNotchSafePadding();
    }
  }

  templateToAvailability = (template, weekStart) => {
    const availabilities = []

    // for each day without any availability - full day delete event(?)
    const allDays = new Set([...Array(7).keys()]);
    const daysInTemplate = new Set()
    template.forEach(event => {
      daysInTemplate.add(event.DayNumber)
    });
    const emptyDays = allDays.difference(daysInTemplate)
    const emptyDayTemplate = Array.from(emptyDays).map(day => {
      return ({
        DayNumber: day,
        StartTime: "00:00",
        EndTime: "23:59",
        AvailabilityType: 'Delete'
      })
    })
    const completeTemplate = template.concat(emptyDayTemplate)

    completeTemplate.forEach(event => {
      let availability = {}
      let [startHour, startMinute] = event.StartTime.split(":").map(e => parseInt(e))
      let [endHour, endMinute] = event.EndTime.split(":").map(e => parseInt(e))
      let eventStartDate = set(addDays(weekStart, event.DayNumber), { hours: startHour, minutes: startMinute })
      let eventEndDate = set(addDays(weekStart, event.DayNumber), { hours: endHour, minutes: endMinute })
      availability.start_date = eventStartDate
      availability.end_date = eventEndDate
      availability.eventType = [event.AvailabilityType]
      availability.pagingNumber = this.props.selectedPagingGroups
      availability.currentDate = format(eventStartDate, "yyyy-MM-dd")
      availabilities.push(availability)
    });
    return availabilities
  }

  setTimeFormat(state) {
    scheduler.config.first_hour = 0;
    scheduler.config.last_hour = 24;
    scheduler.templates.hour_scale = function (date) {
      return date.getHours();
    };

  }
  render() {
    const { timeFormatState } = this.props;
    this.setTimeFormat(timeFormatState);
    return (
      <>
        {this.schedulerHeaderDetails()}
        <div id="scheduler_wrapper">
          <div
            id="scheduler"
            ref={(input) => { this.schedulerContainer = input }}>
            {this.state.isComponentLoading ? (<div className="loader-container"><Loader /></div>) : (<></>)}
          </div>
        </div>
      </>
    );
  }
}
